import { Course, Lesson, Material } from "../../model/model";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Layout } from "../../components/custom-icons/ScreenLayoutIcon";

interface LessonState {
  course: Course | null;
  lesson: Lesson | null;
  /** selected material for viewer */
  material: Material | null;
  layout: Layout;
}

const initialState: LessonState = {
  course: null,
  lesson: null,
  material: null,
  layout: { list: true, support: true },
};

const lessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    setLesson: (state, action: PayloadAction<LessonState["lesson"]>) => {
      state.lesson = action.payload;
    },
    setCourse: (state, action: PayloadAction<LessonState["course"]>) => {
      state.course = action.payload;
    },
    setLayout: (state, action: PayloadAction<LessonState["layout"]>) => {
      state.layout = action.payload;
    },
    setMaterial: (state, action: PayloadAction<LessonState["material"]>) => {
      state.material = action.payload;
    },
  },
});

export const lessonActions = lessonSlice.actions;
export default lessonSlice.reducer;
